import Button from 'features/portal/Button';

function Action({ actionTrigger }) {

    return (
        <div className="filter-actions">
            <Button isPrimary={true} onClick={() => { actionTrigger('search') }} >Search Documents</Button>
            <Button onClick={() => { actionTrigger('clear') }} >Clear All</Button>
            <Button isPrimary={true} href="/epa-regions">EPA Regions</Button>
        </div>
        
    )
}

export default Action;